(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8928],{

/***/ 63847:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},D="en",v={};v[D]=M;var p=function(t){return t instanceof _},S=function(t,e,n){var r;if(!t)return D;if("string"==typeof t)v[t]&&(r=t),e&&(v[t]=e,r=t);else{var i=t.name;v[i]=t,r=i}return!n&&r&&(D=r),r||!n&&D},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var D=this.$locale().weekStart||0,v=(y<D?y+7:y)-D;return $(r?m-v:m+(6-v),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,D=O.m(this,M);return D=(l={},l[c]=D/12,l[f]=D,l[h]=D/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?D:O.a(D)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return v[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=v[D],w.Ls=v,w.p={},w}));

/***/ }),

/***/ 36947:
/***/ (function(module) {

!function(t,i){ true?module.exports=i():0}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t)};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else r.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&null===(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s)))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||(new Date).getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));

/***/ }),

/***/ 77068:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Typography_2ZjCxfuP_C; },
  "H2": function() { return /* reexport */ p; },
  "H3": function() { return /* reexport */ x; },
  "H4": function() { return /* reexport */ j; }
});

// UNUSED EXPORTS: Badge, Button, Checkbox, H1, H5, H6, HabitatTheme, Inline, Switch, colors, corners, mq, space, vars

;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/theme.js
/* empty css                              */
var a = "w88n370", theme_n = { colors: { background: { default: { light: "var(--w88n371)", dark: "var(--w88n372)" }, primary: { dark: "var(--w88n373)", light: "var(--w88n374)" }, secondary: { dark: "var(--w88n375)", light: "var(--w88n376)" } }, brand: { primary: "var(--w88n377)", secondary: "var(--w88n378)", accent: "var(--w88n379)", "primary-light": "var(--w88n37a)", "secondary-light": "var(--w88n37b)" }, buttons: { light: { text: { primary: "var(--w88n37c)", inverted: "var(--w88n37d)", disabled: "var(--w88n37e)", round: "var(--w88n37f)" }, background: { default: "var(--w88n37g)", inverted: "var(--w88n37h)", hover: "var(--w88n37i)", "hover-tertiary": "var(--w88n37j)", "active, pressed": "var(--w88n37k)", disabled: "var(--w88n37l)", "round-default": "var(--w88n37m)", "round-hover": "var(--w88n37n)" }, border: { default: "var(--w88n37o)", hover: "var(--w88n37p)", "active, pressed": "var(--w88n37q)", disabled: "var(--w88n37r)", "hover-tertiary": "var(--w88n37s)", "round-default": "var(--w88n37t)", "round-hover": "var(--w88n37u)" } }, dark: { text: { primary: "var(--w88n37v)", inverted: "var(--w88n37w)", disabled: "var(--w88n37x)", round: "var(--w88n37y)" }, background: { default: "var(--w88n37z)", inverted: "var(--w88n3710)", hover: "var(--w88n3711)", "hover-tertiary": "var(--w88n3712)", "active, pressed": "var(--w88n3713)", disabled: "var(--w88n3714)", "round-default": "var(--w88n3715)", "round-hover": "var(--w88n3716)" }, border: { default: "var(--w88n3717)", hover: "var(--w88n3718)", "active, pressed": "var(--w88n3719)", disabled: "var(--w88n371a)", "hover-tertiary": "var(--w88n371b)", "round-default": "var(--w88n371c)", "round-hover": "var(--w88n371d)" } } }, foreground: { critical: { default: "var(--w88n371e)", light: "var(--w88n371f)" }, success: { default: "var(--w88n371g)", background: "var(--w88n371h)" }, warning: { default: "var(--w88n371i)", light: "var(--w88n371j)" }, text: { primary: "var(--w88n371k)", secondary: "var(--w88n371l)", inverted: "var(--w88n371m)", hover: "var(--w88n371n)", placeholder: "var(--w88n371o)" }, border: { default: "var(--w88n371p)", "hover, active": "var(--w88n371q)", critical: "var(--w88n371r)", disabled: "var(--w88n371s)" }, surface: { disabled: "var(--w88n371t)", default: "var(--w88n371u)", "pressed, active": "var(--w88n371v)" } }, root: { orange: { 300: "var(--w88n371w)", 400: "var(--w88n371x)", 500: "var(--w88n371y)", 600: "var(--w88n371z)", 700: "var(--w88n3720)" }, darkgreen: { 300: "var(--w88n3721)", 400: "var(--w88n3722)", 500: "var(--w88n3723)", 600: "var(--w88n3724)", 700: "var(--w88n3725)" }, teal: { 500: "var(--w88n3726)" }, neutral: { 0: "var(--w88n3727)", 50: "var(--w88n3728)", 100: "var(--w88n3729)", 200: "var(--w88n372a)", 300: "var(--w88n372b)", 400: "var(--w88n372c)", 500: "var(--w88n372d)", 600: "var(--w88n372e)" }, red: { 100: "var(--w88n372f)", 200: "var(--w88n372g)", 300: "var(--w88n372h)", 400: "var(--w88n372i)", 500: "var(--w88n372j)", 600: "var(--w88n372k)" }, green: { 100: "var(--w88n372l)", 200: "var(--w88n372m)", 300: "var(--w88n372n)", 400: "var(--w88n372o)", 500: "var(--w88n372p)", 600: "var(--w88n372q)" }, yellow: { 100: "var(--w88n372r)", 200: "var(--w88n372s)", 300: "var(--w88n372t)", 400: "var(--w88n372u)", 500: "var(--w88n372v)", 600: "var(--w88n372w)" }, offwhite: { 100: "var(--w88n372x)" }, glass: { 100: "var(--w88n372y)" } } }, corners: { 50: "var(--w88n372z)", 100: "var(--w88n3730)", 200: "var(--w88n3731)", 300: "var(--w88n3732)", 400: "var(--w88n3733)", 1e3: "var(--w88n3734)" }, mq: { desktop: "var(--w88n3735)", desktopHD: "var(--w88n3736)", desktopSD: "var(--w88n3737)", mobile: "var(--w88n3738)", tablet: "var(--w88n3739)" }, space: { 0: "var(--w88n373a)", 25: "var(--w88n373b)", 50: "var(--w88n373c)", 75: "var(--w88n373d)", 100: "var(--w88n373e)", 125: "var(--w88n373f)", 150: "var(--w88n373g)", 175: "var(--w88n373h)", 200: "var(--w88n373i)", 225: "var(--w88n373j)", 250: "var(--w88n373k)", 300: "var(--w88n373l)", 400: "var(--w88n373m)", 500: "var(--w88n373n)", 600: "var(--w88n373o)", 800: "var(--w88n373p)", 1e3: "var(--w88n373q)", 1800: "var(--w88n373r)" } };

//# sourceMappingURL=theme.js.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/createRuntimeFn-62c9670f.esm-CXdMsbWY.js

var Z = { exports: {} }, createRuntimeFn_62c9670f_esm_CXdMsbWY_W = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pr;
function de() {
  if (Pr)
    return createRuntimeFn_62c9670f_esm_CXdMsbWY_W;
  Pr = 1;
  var a = react, o = Symbol.for("react.element"), l = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, m = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, w = { key: !0, ref: !0, __self: !0, __source: !0 };
  function P(_, d, T) {
    var y, R = {}, j = null, V = null;
    T !== void 0 && (j = "" + T), d.key !== void 0 && (j = "" + d.key), d.ref !== void 0 && (V = d.ref);
    for (y in d)
      s.call(d, y) && !w.hasOwnProperty(y) && (R[y] = d[y]);
    if (_ && _.defaultProps)
      for (y in d = _.defaultProps, d)
        R[y] === void 0 && (R[y] = d[y]);
    return { $$typeof: o, type: _, key: j, ref: V, props: R, _owner: m.current };
  }
  return createRuntimeFn_62c9670f_esm_CXdMsbWY_W.Fragment = l, createRuntimeFn_62c9670f_esm_CXdMsbWY_W.jsx = P, createRuntimeFn_62c9670f_esm_CXdMsbWY_W.jsxs = P, createRuntimeFn_62c9670f_esm_CXdMsbWY_W;
}
var Y = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tr;
function pe() {
  return Tr || (Tr = 1,  false && 0), Y;
}
 true ? Z.exports = de() : 0;
var Ee = Z.exports;
function be(a, o) {
  if (typeof a != "object" || !a)
    return a;
  var l = a[Symbol.toPrimitive];
  if (l !== void 0) {
    var s = l.call(a, o || "default");
    if (typeof s != "object")
      return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(a);
}
function ye(a) {
  var o = be(a, "string");
  return typeof o == "symbol" ? o : String(o);
}
function ge(a, o, l) {
  return o = ye(o), o in a ? Object.defineProperty(a, o, {
    value: l,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[o] = l, a;
}
function wr(a, o) {
  var l = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(a);
    o && (s = s.filter(function(m) {
      return Object.getOwnPropertyDescriptor(a, m).enumerable;
    })), l.push.apply(l, s);
  }
  return l;
}
function jr(a) {
  for (var o = 1; o < arguments.length; o++) {
    var l = arguments[o] != null ? arguments[o] : {};
    o % 2 ? wr(Object(l), !0).forEach(function(s) {
      ge(a, s, l[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(l)) : wr(Object(l)).forEach(function(s) {
      Object.defineProperty(a, s, Object.getOwnPropertyDescriptor(l, s));
    });
  }
  return a;
}
function Sr(a, o) {
  var l = {};
  for (var s in a)
    l[s] = o(a[s], s);
  return l;
}
var me = (a, o, l) => {
  for (var s of Object.keys(a)) {
    var m;
    if (a[s] !== ((m = o[s]) !== null && m !== void 0 ? m : l[s]))
      return !1;
  }
  return !0;
}, Re = (a) => {
  var o = (l) => {
    var s = a.defaultClassName, m = jr(jr({}, a.defaultVariants), l);
    for (var w in m) {
      var P, _ = (P = m[w]) !== null && P !== void 0 ? P : a.defaultVariants[w];
      if (_ != null) {
        var d = _;
        typeof d == "boolean" && (d = d === !0 ? "true" : "false");
        var T = (
          // @ts-expect-error
          a.variantClassNames[w][d]
        );
        T && (s += " " + T);
      }
    }
    for (var [y, R] of a.compoundVariants)
      me(y, m, a.defaultVariants) && (s += " " + R);
    return s;
  };
  return o.variants = () => Object.keys(a.variantClassNames), o.classNames = {
    get base() {
      return a.defaultClassName.split(" ")[0];
    },
    get variants() {
      return Sr(a.variantClassNames, (l) => Sr(l, (s) => s.split(" ")[0]));
    }
  }, o;
};

//# sourceMappingURL=createRuntimeFn-62c9670f.esm-CXdMsbWY.js.map

;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/Typography-2ZjCxfuP.js


/* empty css                              */
var Typography_2ZjCxfuP_r = Re({ defaultClassName: "_3igy4n1", variantClassNames: { display: { true: "_3igy4n2" }, element: { h1: "_3igy4n3", h2: "_3igy4n4", h3: "_3igy4n5", h4: "_3igy4n6", h5: "_3igy4n7", h6: "_3igy4n8" }, noMargin: { true: "_3igy4n9" } }, defaultVariants: {}, compoundVariants: [] }), y = Re({ defaultClassName: "_3igy4nb _3igy4na", variantClassNames: { noMargin: { true: "_3igy4nc" }, size: { l: "_3igy4nd", m: "_3igy4ne", s: "_3igy4nf", xs: "_3igy4ng" }, strong: { true: "_3igy4nh" }, underline: { true: "_3igy4ni" } }, defaultVariants: {}, compoundVariants: [] }), d = Re({ defaultClassName: "_3igy4nj", variantClassNames: { italic: { true: "_3igy4nk" }, strong: { true: "_3igy4nl" }, underline: { true: "_3igy4nm" } }, defaultVariants: {}, compoundVariants: [] });
const Typography_2ZjCxfuP_t = (s, e) => {
  const n = {};
  return s && (n.dangerouslySetInnerHTML = { __html: s }), e && (n.style = { color: Typography_2ZjCxfuP_m(e) }), n;
}, Typography_2ZjCxfuP_m = (s) => {
  const e = theme_n.colors.root.neutral[600], n = s == null ? void 0 : s.split(".");
  return n && n.reduce((i, c) => i[c], theme_n.colors) || e;
}, N = ({ children: s, color: e, display: n, html: a, noMargin: i }) => /* @__PURE__ */ l.jsx(
  "h1",
  {
    className: Typography_2ZjCxfuP_r({ display: n, element: "h1", noMargin: i }),
    ...Typography_2ZjCxfuP_t(a, e),
    children: a ? null : s
  }
), p = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ Ee.jsx(
  "h2",
  {
    className: Typography_2ZjCxfuP_r({ element: "h2", noMargin: a }),
    ...Typography_2ZjCxfuP_t(n, e),
    children: n ? null : s
  }
), x = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ Ee.jsx(
  "h3",
  {
    className: Typography_2ZjCxfuP_r({ element: "h3", noMargin: a }),
    ...Typography_2ZjCxfuP_t(n, e),
    children: n ? null : s
  }
), j = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ Ee.jsx(
  "h4",
  {
    className: Typography_2ZjCxfuP_r({ element: "h4", noMargin: a }),
    ...Typography_2ZjCxfuP_t(n, e),
    children: n ? null : s
  }
), H = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ l.jsx(
  "h5",
  {
    className: Typography_2ZjCxfuP_r({ element: "h5", noMargin: a }),
    ...Typography_2ZjCxfuP_t(n, e),
    children: n ? null : s
  }
), v = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ l.jsx(
  "h6",
  {
    className: Typography_2ZjCxfuP_r({ element: "h6", noMargin: a }),
    ...Typography_2ZjCxfuP_t(n, e),
    children: n ? null : s
  }
), Typography_2ZjCxfuP_C = ({
  children: s,
  color: e,
  html: n,
  size: a = "m",
  strong: i = !1,
  underline: c = !1,
  noMargin: g = !1
}) => /* @__PURE__ */ Ee.jsx(
  "p",
  {
    className: y({ noMargin: g, size: a, strong: i, underline: c }),
    ...Typography_2ZjCxfuP_t(n, e),
    children: n ? null : s
  }
), Typography_2ZjCxfuP_V = ({
  children: s,
  color: e,
  italic: n = !1,
  html: a,
  strong: i = !1,
  underline: c = !1
}) => /* @__PURE__ */ l.jsx(
  "span",
  {
    className: d({ italic: n, strong: i, underline: c }),
    ...Typography_2ZjCxfuP_t(a, e),
    children: a ? null : s
  }
);

//# sourceMappingURL=Typography-2ZjCxfuP.js.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(29515);
;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/import-_PjWeMm4.js


const import_PjWeMm4_j = typeof document < "u" ? react.useLayoutEffect : () => {
};
function K(e) {
  const t = (0,react.useRef)(null);
  return import_PjWeMm4_j(() => {
    t.current = e;
  }, [
    e
  ]), (0,react.useCallback)((...r) => {
    const n = t.current;
    return n == null ? void 0 : n(...r);
  }, []);
}
function Ft(e) {
  let [t, r] = (0,react.useState)(e), n = (0,react.useRef)(null), i = K(() => {
    if (!n.current)
      return;
    let o = n.current.next();
    if (o.done) {
      n.current = null;
      return;
    }
    t === o.value ? i() : r(o.value);
  });
  import_PjWeMm4_j(() => {
    n.current && i();
  });
  let l = K((o) => {
    n.current = o(t), i();
  });
  return [
    t,
    l
  ];
}
const ce = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, at = /* @__PURE__ */ react.createContext(ce), kt = /* @__PURE__ */ react.createContext(!1);
let Rt = !!(typeof window < "u" && window.document && window.document.createElement), he = /* @__PURE__ */ new WeakMap();
function zt(e = !1) {
  let t = (0,react.useContext)(at), r = (0,react.useRef)(null);
  if (r.current === null && !e) {
    var n, i;
    let l = (i = react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (n = i.ReactCurrentOwner) === null || n === void 0 ? void 0 : n.current;
    if (l) {
      let o = he.get(l);
      o == null ? he.set(l, {
        id: t.current,
        state: l.memoizedState
      }) : l.memoizedState !== o.state && (t.current = o.id, he.delete(l));
    }
    r.current = ++t.current;
  }
  return r.current;
}
function Ht(e) {
  let t = (0,react.useContext)(at);
  t === ce && !Rt && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let r = zt(!!e), n = t === ce && "production" === "test" ? 0 : `react-aria${t.prefix}`;
  return e || `${n}-${r}`;
}
function Kt(e) {
  let t = react.useId(), [r] = (0,react.useState)(ot()), n = r || "production" === "test" ? "react-aria" : `react-aria${ce.prefix}`;
  return e || `${n}-${t}`;
}
const Nt = typeof react.useId == "function" ? Kt : Ht;
function _t() {
  return !1;
}
function At() {
  return !0;
}
function Bt(e) {
  return () => {
  };
}
function ot() {
  return typeof react.useSyncExternalStore == "function" ? react.useSyncExternalStore(Bt, _t, At) : (0,react.useContext)(kt);
}
let Wt = !!(typeof window < "u" && window.document && window.document.createElement), fe = /* @__PURE__ */ new Map();
function import_PjWeMm4_pe(e) {
  let [t, r] = (0,react.useState)(e), n = (0,react.useRef)(null), i = Nt(t), l = (0,react.useCallback)((o) => {
    n.current = o;
  }, []);
  return Wt && fe.set(i, l), import_PjWeMm4_j(() => {
    let o = i;
    return () => {
      fe.delete(o);
    };
  }, [
    i
  ]), (0,react.useEffect)(() => {
    let o = n.current;
    o && (n.current = null, r(o));
  }), i;
}
function Ut(e, t) {
  if (e === t)
    return e;
  let r = fe.get(e);
  if (r)
    return r(t), t;
  let n = fe.get(t);
  return n ? (n(e), e) : t;
}
function Ue(e = []) {
  let t = import_PjWeMm4_pe(), [r, n] = Ft(t), i = (0,react.useCallback)(() => {
    n(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    n
  ]);
  return import_PjWeMm4_j(i, [
    t,
    i,
    ...e
  ]), r;
}
function lt(...e) {
  return (...t) => {
    for (let r of e)
      typeof r == "function" && r(...t);
  };
}
const z = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, _ = (e) => e && "window" in e && e.window === e ? e : z(e).defaultView || window;
function st(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var i = e.length;
      for (t = 0; t < i; t++)
        e[t] && (r = st(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function jt() {
  for (var e, t, r = 0, n = "", i = arguments.length; r < i; r++)
    (e = arguments[r]) && (t = st(e)) && (n && (n += " "), n += t);
  return n;
}
function k(...e) {
  let t = {
    ...e[0]
  };
  for (let r = 1; r < e.length; r++) {
    let n = e[r];
    for (let i in n) {
      let l = t[i], o = n[i];
      typeof l == "function" && typeof o == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? t[i] = lt(l, o) : (i === "className" || i === "UNSAFE_className") && typeof l == "string" && typeof o == "string" ? t[i] = jt(l, o) : i === "id" && l && o ? t.id = Ut(l, o) : t[i] = o !== void 0 ? o : l;
    }
  }
  return t;
}
function Jt(...e) {
  return e.length === 1 ? e[0] : (t) => {
    for (let r of e)
      typeof r == "function" ? r(t) : r != null && (r.current = t);
  };
}
const Gt = /* @__PURE__ */ new Set([
  "id"
]), Zt = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), qt = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Yt = /^(data-.*)$/;
function import_PjWeMm4_Z(e, t = {}) {
  let { labelable: r, isLink: n, propNames: i } = t, l = {};
  for (const o in e)
    Object.prototype.hasOwnProperty.call(e, o) && (Gt.has(o) || r && Zt.has(o) || n && qt.has(o) || i != null && i.has(o) || Yt.test(o)) && (l[o] = e[o]);
  return l;
}
function J(e) {
  if (Xt())
    e.focus({
      preventScroll: !0
    });
  else {
    let t = Qt(e);
    e.focus(), er(t);
  }
}
let oe = null;
function Xt() {
  if (oe == null) {
    oe = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return oe = !0, !0;
        }
      });
    } catch {
    }
  }
  return oe;
}
function Qt(e) {
  let t = e.parentNode, r = [], n = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== n; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && r.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return n instanceof HTMLElement && r.push({
    element: n,
    scrollTop: n.scrollTop,
    scrollLeft: n.scrollLeft
  }), r;
}
function er(e) {
  for (let { element: t, scrollTop: r, scrollLeft: n } of e)
    t.scrollTop = r, t.scrollLeft = n;
}
function $e(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function He(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function ne() {
  return He(/^Mac/i);
}
function tr() {
  return He(/^iPhone/i);
}
function dt() {
  return He(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  ne() && navigator.maxTouchPoints > 1;
}
function ut() {
  return tr() || dt();
}
function rr() {
  return $e(/AppleWebKit/i) && !nr();
}
function nr() {
  return $e(/Chrome/i);
}
function ct() {
  return $e(/Android/i);
}
function ir() {
  return $e(/Firefox/i);
}
function ie(e, t, r = !0) {
  var n, i;
  let { metaKey: l, ctrlKey: o, altKey: s, shiftKey: d } = t;
  ir() && (!((i = window.event) === null || i === void 0 || (n = i.type) === null || n === void 0) && n.startsWith("key")) && e.target === "_blank" && (ne() ? l = !0 : o = !0);
  let c = rr() && ne() && !dt() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: l,
    ctrlKey: o,
    altKey: s,
    shiftKey: d
  }) : new MouseEvent("click", {
    metaKey: l,
    ctrlKey: o,
    altKey: s,
    shiftKey: d,
    bubbles: !0,
    cancelable: !0
  });
  ie.isOpening = r, J(e), e.dispatchEvent(c), ie.isOpening = !1;
}
ie.isOpening = !1;
let Q = /* @__PURE__ */ new Map(), Le = /* @__PURE__ */ new Set();
function je() {
  if (typeof window > "u")
    return;
  function e(n) {
    return "propertyName" in n;
  }
  let t = (n) => {
    if (!e(n) || !n.target)
      return;
    let i = Q.get(n.target);
    i || (i = /* @__PURE__ */ new Set(), Q.set(n.target, i), n.target.addEventListener("transitioncancel", r, {
      once: !0
    })), i.add(n.propertyName);
  }, r = (n) => {
    if (!e(n) || !n.target)
      return;
    let i = Q.get(n.target);
    if (i && (i.delete(n.propertyName), i.size === 0 && (n.target.removeEventListener("transitioncancel", r), Q.delete(n.target)), Q.size === 0)) {
      for (let l of Le)
        l();
      Le.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", r);
}
typeof document < "u" && (document.readyState !== "loading" ? je() : document.addEventListener("DOMContentLoaded", je));
function ft(e) {
  requestAnimationFrame(() => {
    Q.size === 0 ? e() : Le.add(e);
  });
}
function ar() {
  let e = (0,react.useRef)(/* @__PURE__ */ new Map()), t = (0,react.useCallback)((i, l, o, s) => {
    let d = s != null && s.once ? (...c) => {
      e.current.delete(o), o(...c);
    } : o;
    e.current.set(o, {
      type: l,
      eventTarget: i,
      fn: d,
      options: s
    }), i.addEventListener(l, o, s);
  }, []), r = (0,react.useCallback)((i, l, o, s) => {
    var d;
    let c = ((d = e.current.get(o)) === null || d === void 0 ? void 0 : d.fn) || o;
    i.removeEventListener(l, c, s), e.current.delete(o);
  }, []), n = (0,react.useCallback)(() => {
    e.current.forEach((i, l) => {
      r(i.eventTarget, i.type, l, i.options);
    });
  }, [
    r
  ]);
  return (0,react.useEffect)(() => n, [
    n
  ]), {
    addGlobalListener: t,
    removeGlobalListener: r,
    removeAllGlobalListeners: n
  };
}
function or(e, t) {
  let { id: r, "aria-label": n, "aria-labelledby": i } = e;
  return r = import_PjWeMm4_pe(r), i && n ? i = [
    .../* @__PURE__ */ new Set([
      r,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !n && !i && t && (n = t), {
    id: r,
    "aria-label": n,
    "aria-labelledby": i
  };
}
function lr(e) {
  const t = (0,react.useRef)(null);
  return (0,react.useMemo)(() => ({
    get current() {
      return t.current;
    },
    set current(r) {
      t.current = r, typeof e == "function" ? e(r) : e && (e.current = r);
    }
  }), [
    e
  ]);
}
function pt(e, t) {
  import_PjWeMm4_j(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Oe(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : ct() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function sr(e) {
  return !ct() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function vt(e, t, r) {
  let n = (0,react.useRef)(t), i = K(() => {
    r && r(n.current);
  });
  (0,react.useEffect)(() => {
    var l;
    let o = e == null || (l = e.current) === null || l === void 0 ? void 0 : l.form;
    return o == null || o.addEventListener("reset", i), () => {
      o == null || o.removeEventListener("reset", i);
    };
  }, [
    e,
    i
  ]);
}
function bt(e, t, r) {
  let [n, i] = (0,react.useState)(e || t), l = (0,react.useRef)(e !== void 0), o = e !== void 0;
  (0,react.useEffect)(() => {
    let c = l.current;
    c !== o && console.warn(`WARN: A component changed from ${c ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}.`), l.current = o;
  }, [
    o
  ]);
  let s = o ? e : n, d = (0,react.useCallback)((c, ...g) => {
    let b = ($, ...p) => {
      r && (Object.is(s, $) || r($, ...p)), o || (s = $);
    };
    typeof c == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), i((p, ...E) => {
      let h = c(o ? s : p, ...E);
      return b(h, ...g), o ? p : h;
    })) : (o || i(c), b(c, ...g));
  }, [
    o,
    s,
    r
  ]);
  return [
    s,
    d
  ];
}
let te = "default", De = "", ue = /* @__PURE__ */ new WeakMap();
function Je(e) {
  if (ut()) {
    if (te === "default") {
      const t = z(e);
      De = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    te = "disabled";
  } else
    (e instanceof HTMLElement || e instanceof SVGElement) && (ue.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function le(e) {
  if (ut()) {
    if (te !== "disabled")
      return;
    te = "restoring", setTimeout(() => {
      ft(() => {
        if (te === "restoring") {
          const t = z(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = De || ""), De = "", te = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && ue.has(e)) {
    let t = ue.get(e);
    e.style.userSelect === "none" && (e.style.userSelect = t), e.getAttribute("style") === "" && e.removeAttribute("style"), ue.delete(e);
  }
}
const $t = react.createContext({
  register: () => {
  }
});
$t.displayName = "PressResponderContext";
function dr(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function gt(e, t, r) {
  if (!t.has(e))
    throw new TypeError("attempted to " + r + " private field on non-instance");
  return t.get(e);
}
function ur(e, t) {
  var r = gt(e, t, "get");
  return dr(e, r);
}
function cr(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function fr(e, t, r) {
  cr(e, t), t.set(e, r);
}
function pr(e, t, r) {
  if (t.set)
    t.set.call(e, r);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = r;
  }
}
function Ge(e, t, r) {
  var n = gt(e, t, "set");
  return pr(e, n, r), r;
}
function vr(e) {
  let t = (0,react.useContext)($t);
  if (t) {
    let { register: r, ...n } = t;
    e = k(n, e), r();
  }
  return pt(t, e.ref), e;
}
var se = /* @__PURE__ */ new WeakMap();
class import_PjWeMm4_de {
  continuePropagation() {
    Ge(this, se, !1);
  }
  get shouldStopPropagation() {
    return ur(this, se);
  }
  constructor(t, r, n) {
    fr(this, se, {
      writable: !0,
      value: void 0
    }), Ge(this, se, !0), this.type = t, this.pointerType = r, this.target = n.currentTarget, this.shiftKey = n.shiftKey, this.metaKey = n.metaKey, this.ctrlKey = n.ctrlKey, this.altKey = n.altKey;
  }
}
const Ze = Symbol("linkClicked");
function ae(e) {
  let {
    onPress: t,
    onPressChange: r,
    onPressStart: n,
    onPressEnd: i,
    onPressUp: l,
    isDisabled: o,
    isPressed: s,
    preventFocusOnPress: d,
    shouldCancelOnPointerExit: c,
    allowTextSelectionOnPress: g,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: b,
    ...$
  } = vr(e), [p, E] = (0,react.useState)(!1), h = (0,react.useRef)({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: S, removeAllGlobalListeners: D } = ar(), w = K((a, P) => {
    let x = h.current;
    if (o || x.didFirePressStart)
      return !1;
    let v = !0;
    if (x.isTriggeringEvent = !0, n) {
      let I = new import_PjWeMm4_de("pressstart", P, a);
      n(I), v = I.shouldStopPropagation;
    }
    return r && r(!0), x.isTriggeringEvent = !1, x.didFirePressStart = !0, E(!0), v;
  }), m = K((a, P, x = !0) => {
    let v = h.current;
    if (!v.didFirePressStart)
      return !1;
    v.ignoreClickAfterPress = !0, v.didFirePressStart = !1, v.isTriggeringEvent = !0;
    let I = !0;
    if (i) {
      let u = new import_PjWeMm4_de("pressend", P, a);
      i(u), I = u.shouldStopPropagation;
    }
    if (r && r(!1), E(!1), t && x && !o) {
      let u = new import_PjWeMm4_de("press", P, a);
      t(u), I && (I = u.shouldStopPropagation);
    }
    return v.isTriggeringEvent = !1, I;
  }), y = K((a, P) => {
    let x = h.current;
    if (o)
      return !1;
    if (l) {
      x.isTriggeringEvent = !0;
      let v = new import_PjWeMm4_de("pressup", P, a);
      return l(v), x.isTriggeringEvent = !1, v.shouldStopPropagation;
    }
    return !0;
  }), T = K((a) => {
    let P = h.current;
    P.isPressed && P.target && (P.isOverTarget && P.pointerType != null && m(B(P.target, a), P.pointerType, !1), P.isPressed = !1, P.isOverTarget = !1, P.activePointerId = null, P.pointerType = null, D(), g || le(P.target));
  }), L = K((a) => {
    c && T(a);
  }), N = (0,react.useMemo)(() => {
    let a = h.current, P = {
      onKeyDown(v) {
        if (Pe(v.nativeEvent, v.currentTarget) && v.currentTarget.contains(v.target)) {
          var I;
          Ye(v.target, v.key) && v.preventDefault();
          let u = !0;
          if (!a.isPressed && !v.repeat) {
            a.target = v.currentTarget, a.isPressed = !0, u = w(v, "keyboard");
            let f = v.currentTarget, M = (Y) => {
              Pe(Y, f) && !Y.repeat && f.contains(Y.target) && a.target && y(B(a.target, Y), "keyboard");
            };
            S(z(v.currentTarget), "keyup", lt(M, x), !0);
          }
          u && v.stopPropagation(), v.metaKey && ne() && ((I = a.metaKeyEvents) === null || I === void 0 || I.set(v.key, v.nativeEvent));
        } else
          v.key === "Meta" && (a.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(v) {
        if (!(v && !v.currentTarget.contains(v.target)) && v && v.button === 0 && !a.isTriggeringEvent && !ie.isOpening) {
          let I = !0;
          if (o && v.preventDefault(), !a.ignoreClickAfterPress && !a.ignoreEmulatedMouseEvents && !a.isPressed && (a.pointerType === "virtual" || Oe(v.nativeEvent))) {
            !o && !d && J(v.currentTarget);
            let u = w(v, "virtual"), f = y(v, "virtual"), M = m(v, "virtual");
            I = u && f && M;
          }
          a.ignoreEmulatedMouseEvents = !1, a.ignoreClickAfterPress = !1, I && v.stopPropagation();
        }
      }
    }, x = (v) => {
      var I;
      if (a.isPressed && a.target && Pe(v, a.target)) {
        var u;
        Ye(v.target, v.key) && v.preventDefault();
        let M = v.target;
        m(B(a.target, v), "keyboard", a.target.contains(M)), D(), v.key !== "Enter" && Ke(a.target) && a.target.contains(M) && !v[Ze] && (v[Ze] = !0, ie(a.target, v, !1)), a.isPressed = !1, (u = a.metaKeyEvents) === null || u === void 0 || u.delete(v.key);
      } else if (v.key === "Meta" && (!((I = a.metaKeyEvents) === null || I === void 0) && I.size)) {
        var f;
        let M = a.metaKeyEvents;
        a.metaKeyEvents = void 0;
        for (let Y of M.values())
          (f = a.target) === null || f === void 0 || f.dispatchEvent(new KeyboardEvent("keyup", Y));
      }
    };
    if (typeof PointerEvent < "u") {
      P.onPointerDown = (f) => {
        if (f.button !== 0 || !f.currentTarget.contains(f.target))
          return;
        if (sr(f.nativeEvent)) {
          a.pointerType = "virtual";
          return;
        }
        import_PjWeMm4_Ee(f.currentTarget) && f.preventDefault(), a.pointerType = f.pointerType;
        let M = !0;
        a.isPressed || (a.isPressed = !0, a.isOverTarget = !0, a.activePointerId = f.pointerId, a.target = f.currentTarget, !o && !d && J(f.currentTarget), g || Je(a.target), M = w(f, a.pointerType), S(z(f.currentTarget), "pointermove", v, !1), S(z(f.currentTarget), "pointerup", I, !1), S(z(f.currentTarget), "pointercancel", u, !1)), M && f.stopPropagation();
      }, P.onMouseDown = (f) => {
        f.currentTarget.contains(f.target) && f.button === 0 && (import_PjWeMm4_Ee(f.currentTarget) && f.preventDefault(), f.stopPropagation());
      }, P.onPointerUp = (f) => {
        !f.currentTarget.contains(f.target) || a.pointerType === "virtual" || f.button === 0 && X(f, f.currentTarget) && y(f, a.pointerType || f.pointerType);
      };
      let v = (f) => {
        f.pointerId === a.activePointerId && (a.target && X(f, a.target) ? !a.isOverTarget && a.pointerType != null && (a.isOverTarget = !0, w(B(a.target, f), a.pointerType)) : a.target && a.isOverTarget && a.pointerType != null && (a.isOverTarget = !1, m(B(a.target, f), a.pointerType, !1), L(f)));
      }, I = (f) => {
        f.pointerId === a.activePointerId && a.isPressed && f.button === 0 && a.target && (X(f, a.target) && a.pointerType != null ? m(B(a.target, f), a.pointerType) : a.isOverTarget && a.pointerType != null && m(B(a.target, f), a.pointerType, !1), a.isPressed = !1, a.isOverTarget = !1, a.activePointerId = null, a.pointerType = null, D(), g || le(a.target));
      }, u = (f) => {
        T(f);
      };
      P.onDragStart = (f) => {
        f.currentTarget.contains(f.target) && T(f);
      };
    } else {
      P.onMouseDown = (u) => {
        if (u.button !== 0 || !u.currentTarget.contains(u.target))
          return;
        if (import_PjWeMm4_Ee(u.currentTarget) && u.preventDefault(), a.ignoreEmulatedMouseEvents) {
          u.stopPropagation();
          return;
        }
        a.isPressed = !0, a.isOverTarget = !0, a.target = u.currentTarget, a.pointerType = Oe(u.nativeEvent) ? "virtual" : "mouse", !o && !d && J(u.currentTarget), w(u, a.pointerType) && u.stopPropagation(), S(z(u.currentTarget), "mouseup", v, !1);
      }, P.onMouseEnter = (u) => {
        if (!u.currentTarget.contains(u.target))
          return;
        let f = !0;
        a.isPressed && !a.ignoreEmulatedMouseEvents && a.pointerType != null && (a.isOverTarget = !0, f = w(u, a.pointerType)), f && u.stopPropagation();
      }, P.onMouseLeave = (u) => {
        if (!u.currentTarget.contains(u.target))
          return;
        let f = !0;
        a.isPressed && !a.ignoreEmulatedMouseEvents && a.pointerType != null && (a.isOverTarget = !1, f = m(u, a.pointerType, !1), L(u)), f && u.stopPropagation();
      }, P.onMouseUp = (u) => {
        u.currentTarget.contains(u.target) && !a.ignoreEmulatedMouseEvents && u.button === 0 && y(u, a.pointerType || "mouse");
      };
      let v = (u) => {
        if (u.button === 0) {
          if (a.isPressed = !1, D(), a.ignoreEmulatedMouseEvents) {
            a.ignoreEmulatedMouseEvents = !1;
            return;
          }
          a.target && X(u, a.target) && a.pointerType != null ? m(B(a.target, u), a.pointerType) : a.target && a.isOverTarget && a.pointerType != null && m(B(a.target, u), a.pointerType, !1), a.isOverTarget = !1;
        }
      };
      P.onTouchStart = (u) => {
        if (!u.currentTarget.contains(u.target))
          return;
        let f = br(u.nativeEvent);
        if (!f)
          return;
        a.activePointerId = f.identifier, a.ignoreEmulatedMouseEvents = !0, a.isOverTarget = !0, a.isPressed = !0, a.target = u.currentTarget, a.pointerType = "touch", !o && !d && J(u.currentTarget), g || Je(a.target), w(u, a.pointerType) && u.stopPropagation(), S(_(u.currentTarget), "scroll", I, !0);
      }, P.onTouchMove = (u) => {
        if (!u.currentTarget.contains(u.target))
          return;
        if (!a.isPressed) {
          u.stopPropagation();
          return;
        }
        let f = qe(u.nativeEvent, a.activePointerId), M = !0;
        f && X(f, u.currentTarget) ? !a.isOverTarget && a.pointerType != null && (a.isOverTarget = !0, M = w(u, a.pointerType)) : a.isOverTarget && a.pointerType != null && (a.isOverTarget = !1, M = m(u, a.pointerType, !1), L(u)), M && u.stopPropagation();
      }, P.onTouchEnd = (u) => {
        if (!u.currentTarget.contains(u.target))
          return;
        if (!a.isPressed) {
          u.stopPropagation();
          return;
        }
        let f = qe(u.nativeEvent, a.activePointerId), M = !0;
        f && X(f, u.currentTarget) && a.pointerType != null ? (y(u, a.pointerType), M = m(u, a.pointerType)) : a.isOverTarget && a.pointerType != null && (M = m(u, a.pointerType, !1)), M && u.stopPropagation(), a.isPressed = !1, a.activePointerId = null, a.isOverTarget = !1, a.ignoreEmulatedMouseEvents = !0, a.target && !g && le(a.target), D();
      }, P.onTouchCancel = (u) => {
        u.currentTarget.contains(u.target) && (u.stopPropagation(), a.isPressed && T(u));
      };
      let I = (u) => {
        a.isPressed && u.target.contains(a.target) && T({
          currentTarget: a.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      P.onDragStart = (u) => {
        u.currentTarget.contains(u.target) && T(u);
      };
    }
    return P;
  }, [
    S,
    o,
    d,
    D,
    g,
    T,
    L,
    m,
    w,
    y
  ]);
  return (0,react.useEffect)(() => () => {
    var a;
    g || le((a = h.current.target) !== null && a !== void 0 ? a : void 0);
  }, [
    g
  ]), {
    isPressed: s || p,
    pressProps: k($, N)
  };
}
function Ke(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function Pe(e, t) {
  const { key: r, code: n } = e, i = t, l = i.getAttribute("role");
  return (r === "Enter" || r === " " || r === "Spacebar" || n === "Space") && !(i instanceof _(i).HTMLInputElement && !mt(i, r) || i instanceof _(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((l === "link" || !l && Ke(i)) && r !== "Enter");
}
function br(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function qe(e, t) {
  const r = e.changedTouches;
  for (let n = 0; n < r.length; n++) {
    const i = r[n];
    if (i.identifier === t)
      return i;
  }
  return null;
}
function B(e, t) {
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey
  };
}
function $r(e) {
  let t = 0, r = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? r = e.height / 2 : e.radiusY !== void 0 && (r = e.radiusY), {
    top: e.clientY - r,
    right: e.clientX + t,
    bottom: e.clientY + r,
    left: e.clientX - t
  };
}
function gr(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function X(e, t) {
  let r = t.getBoundingClientRect(), n = $r(e);
  return gr(r, n);
}
function import_PjWeMm4_Ee(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function Ye(e, t) {
  return e instanceof HTMLInputElement ? !mt(e, t) : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Ke(e);
}
const mr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function mt(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : mr.has(e.type);
}
class yr {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, r) {
    this.nativeEvent = r, this.target = r.target, this.currentTarget = r.currentTarget, this.relatedTarget = r.relatedTarget, this.bubbles = r.bubbles, this.cancelable = r.cancelable, this.defaultPrevented = r.defaultPrevented, this.eventPhase = r.eventPhase, this.isTrusted = r.isTrusted, this.timeStamp = r.timeStamp, this.type = t;
  }
}
function yt(e) {
  let t = (0,react.useRef)({
    isFocused: !1,
    observer: null
  });
  import_PjWeMm4_j(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []);
  let r = K((n) => {
    e == null || e(n);
  });
  return (0,react.useCallback)((n) => {
    if (n.target instanceof HTMLButtonElement || n.target instanceof HTMLInputElement || n.target instanceof HTMLTextAreaElement || n.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let i = n.target, l = (o) => {
        t.current.isFocused = !1, i.disabled && r(new yr("blur", o)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      i.addEventListener("focusout", l, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && i.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let s = i === document.activeElement ? null : document.activeElement;
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
function ht(e) {
  let { isDisabled: t, onFocus: r, onBlur: n, onFocusChange: i } = e;
  const l = (0,react.useCallback)((d) => {
    if (d.target === d.currentTarget)
      return n && n(d), i && i(!1), !0;
  }, [
    n,
    i
  ]), o = yt(l), s = (0,react.useCallback)((d) => {
    const c = z(d.target);
    d.target === d.currentTarget && c.activeElement === d.target && (r && r(d), i && i(!0), o(d));
  }, [
    i,
    r,
    o
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || i || n) ? s : void 0,
      onBlur: !t && (n || i) ? l : void 0
    }
  };
}
let q = null, Ie = /* @__PURE__ */ new Set(), re = /* @__PURE__ */ new Map(), G = !1, Me = !1;
const hr = {
  Tab: !0,
  Escape: !0
};
function import_PjWeMm4_ge(e, t) {
  for (let r of Ie)
    r(e, t);
}
function import_PjWeMm4_Pr(e) {
  return !(e.metaKey || !ne() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function ve(e) {
  G = !0, import_PjWeMm4_Pr(e) && (q = "keyboard", import_PjWeMm4_ge("keyboard", e));
}
function import_PjWeMm4_H(e) {
  q = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (G = !0, import_PjWeMm4_ge("pointer", e));
}
function Pt(e) {
  Oe(e) && (G = !0, q = "virtual");
}
function Et(e) {
  e.target === window || e.target === document || (!G && !Me && (q = "virtual", import_PjWeMm4_ge("virtual", e)), G = !1, Me = !1);
}
function St() {
  G = !1, Me = !0;
}
function Ve(e) {
  if (typeof window > "u" || re.get(_(e)))
    return;
  const t = _(e), r = z(e);
  let n = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    G = !0, n.apply(this, arguments);
  }, r.addEventListener("keydown", ve, !0), r.addEventListener("keyup", ve, !0), r.addEventListener("click", Pt, !0), t.addEventListener("focus", Et, !0), t.addEventListener("blur", St, !1), typeof PointerEvent < "u" ? (r.addEventListener("pointerdown", import_PjWeMm4_H, !0), r.addEventListener("pointermove", import_PjWeMm4_H, !0), r.addEventListener("pointerup", import_PjWeMm4_H, !0)) : (r.addEventListener("mousedown", import_PjWeMm4_H, !0), r.addEventListener("mousemove", import_PjWeMm4_H, !0), r.addEventListener("mouseup", import_PjWeMm4_H, !0)), t.addEventListener("beforeunload", () => {
    Tt(e);
  }, {
    once: !0
  }), re.set(t, {
    focus: n
  });
}
const Tt = (e, t) => {
  const r = _(e), n = z(e);
  t && n.removeEventListener("DOMContentLoaded", t), re.has(r) && (r.HTMLElement.prototype.focus = re.get(r).focus, n.removeEventListener("keydown", ve, !0), n.removeEventListener("keyup", ve, !0), n.removeEventListener("click", Pt, !0), r.removeEventListener("focus", Et, !0), r.removeEventListener("blur", St, !1), typeof PointerEvent < "u" ? (n.removeEventListener("pointerdown", import_PjWeMm4_H, !0), n.removeEventListener("pointermove", import_PjWeMm4_H, !0), n.removeEventListener("pointerup", import_PjWeMm4_H, !0)) : (n.removeEventListener("mousedown", import_PjWeMm4_H, !0), n.removeEventListener("mousemove", import_PjWeMm4_H, !0), n.removeEventListener("mouseup", import_PjWeMm4_H, !0)), re.delete(r));
};
function Er(e) {
  const t = z(e);
  let r;
  return t.readyState !== "loading" ? Ve(e) : (r = () => {
    Ve(e);
  }, t.addEventListener("DOMContentLoaded", r)), () => Tt(e, r);
}
typeof document < "u" && Er();
function xt() {
  return q !== "pointer";
}
function import_PjWeMm4_Sr() {
  return q;
}
function import_PjWeMm4_Tr(e) {
  q = e, import_PjWeMm4_ge(e, null);
}
const xr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function import_PjWeMm4_wr(e, t, r) {
  var n;
  const i = typeof window < "u" ? _(r == null ? void 0 : r.target).HTMLInputElement : HTMLInputElement, l = typeof window < "u" ? _(r == null ? void 0 : r.target).HTMLTextAreaElement : HTMLTextAreaElement, o = typeof window < "u" ? _(r == null ? void 0 : r.target).HTMLElement : HTMLElement, s = typeof window < "u" ? _(r == null ? void 0 : r.target).KeyboardEvent : KeyboardEvent;
  return e = e || (r == null ? void 0 : r.target) instanceof i && !xr.has(r == null || (n = r.target) === null || n === void 0 ? void 0 : n.type) || (r == null ? void 0 : r.target) instanceof l || (r == null ? void 0 : r.target) instanceof o && (r == null ? void 0 : r.target.isContentEditable), !(e && t === "keyboard" && r instanceof s && !hr[r.key]);
}
function Lr(e, t, r) {
  Ve(), (0,react.useEffect)(() => {
    let n = (i, l) => {
      import_PjWeMm4_wr(!!(r != null && r.isTextInput), i, l) && e(xt());
    };
    return Ie.add(n), () => {
      Ie.delete(n);
    };
  }, t);
}
function wt(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: n, onFocusWithinChange: i } = e, l = (0,react.useRef)({
    isFocusWithin: !1
  }), o = (0,react.useCallback)((c) => {
    l.current.isFocusWithin && !c.currentTarget.contains(c.relatedTarget) && (l.current.isFocusWithin = !1, r && r(c), i && i(!1));
  }, [
    r,
    i,
    l
  ]), s = yt(o), d = (0,react.useCallback)((c) => {
    !l.current.isFocusWithin && document.activeElement === c.target && (n && n(c), i && i(!0), l.current.isFocusWithin = !0, s(c));
  }, [
    n,
    i,
    s
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: d,
      onBlur: o
    }
  };
}
let import_PjWeMm4_be = !1, Se = 0;
function Ce() {
  import_PjWeMm4_be = !0, setTimeout(() => {
    import_PjWeMm4_be = !1;
  }, 50);
}
function Xe(e) {
  e.pointerType === "touch" && Ce();
}
function Or() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", Xe) : document.addEventListener("touchend", Ce), Se++, () => {
      Se--, !(Se > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Xe) : document.removeEventListener("touchend", Ce));
    };
}
function Ne(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: n, isDisabled: i } = e, [l, o] = (0,react.useState)(!1), s = (0,react.useRef)({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  (0,react.useEffect)(Or, []);
  let { hoverProps: d, triggerHoverEnd: c } = (0,react.useMemo)(() => {
    let g = (p, E) => {
      if (s.pointerType = E, i || E === "touch" || s.isHovered || !p.currentTarget.contains(p.target))
        return;
      s.isHovered = !0;
      let h = p.currentTarget;
      s.target = h, t && t({
        type: "hoverstart",
        target: h,
        pointerType: E
      }), r && r(!0), o(!0);
    }, b = (p, E) => {
      if (s.pointerType = "", s.target = null, E === "touch" || !s.isHovered)
        return;
      s.isHovered = !1;
      let h = p.currentTarget;
      n && n({
        type: "hoverend",
        target: h,
        pointerType: E
      }), r && r(!1), o(!1);
    }, $ = {};
    return typeof PointerEvent < "u" ? ($.onPointerEnter = (p) => {
      import_PjWeMm4_be && p.pointerType === "mouse" || g(p, p.pointerType);
    }, $.onPointerLeave = (p) => {
      !i && p.currentTarget.contains(p.target) && b(p, p.pointerType);
    }) : ($.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, $.onMouseEnter = (p) => {
      !s.ignoreEmulatedMouseEvents && !import_PjWeMm4_be && g(p, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, $.onMouseLeave = (p) => {
      !i && p.currentTarget.contains(p.target) && b(p, "mouse");
    }), {
      hoverProps: $,
      triggerHoverEnd: b
    };
  }, [
    t,
    r,
    n,
    i,
    s
  ]);
  return (0,react.useEffect)(() => {
    i && c({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    i
  ]), {
    hoverProps: d,
    isHovered: l
  };
}
function Qe(e) {
  if (!e)
    return;
  let t = !0;
  return (r) => {
    let n = {
      ...r,
      preventDefault() {
        r.preventDefault();
      },
      isDefaultPrevented() {
        return r.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    };
    e(n), t && r.stopPropagation();
  };
}
function Dr(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Qe(e.onKeyDown),
      onKeyUp: Qe(e.onKeyUp)
    }
  };
}
function Ir(e) {
  const t = z(e);
  if (import_PjWeMm4_Sr() === "virtual") {
    let r = t.activeElement;
    ft(() => {
      t.activeElement === r && e.isConnected && J(e);
    });
  } else
    J(e);
}
function _e(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: n } = e, i = (0,react.useRef)({
    isFocused: !1,
    isFocusVisible: t || xt()
  }), [l, o] = (0,react.useState)(!1), [s, d] = (0,react.useState)(() => i.current.isFocused && i.current.isFocusVisible), c = (0,react.useCallback)(() => d(i.current.isFocused && i.current.isFocusVisible), []), g = (0,react.useCallback)((p) => {
    i.current.isFocused = p, o(p), c();
  }, [
    c
  ]);
  Lr((p) => {
    i.current.isFocusVisible = p, c();
  }, [], {
    isTextInput: r
  });
  let { focusProps: b } = ht({
    isDisabled: n,
    onFocusChange: g
  }), { focusWithinProps: $ } = wt({
    isDisabled: !n,
    onFocusWithinChange: g
  });
  return {
    isFocused: l,
    isFocusVisible: s,
    focusProps: n ? $ : b
  };
}
let Mr = /* @__PURE__ */ react.createContext(null);
function Vr(e) {
  let t = (0,react.useContext)(Mr) || {};
  pt(t, e);
  let { ref: r, ...n } = t;
  return n;
}
function Ae(e, t) {
  let { focusProps: r } = ht(e), { keyboardProps: n } = Dr(e), i = k(r, n), l = Vr(t), o = e.isDisabled ? {} : l, s = (0,react.useRef)(e.autoFocus);
  return (0,react.useEffect)(() => {
    s.current && t.current && Ir(t.current), s.current = !1;
  }, [
    t
  ]), {
    focusableProps: k({
      ...i,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, o)
  };
}
function Cr(e, t) {
  let {
    elementType: r = "button",
    isDisabled: n,
    onPress: i,
    onPressStart: l,
    onPressEnd: o,
    onPressUp: s,
    onPressChange: d,
    preventFocusOnPress: c,
    allowFocusWhenDisabled: g,
    // @ts-ignore
    onClick: b,
    href: $,
    target: p,
    rel: E,
    type: h = "button"
  } = e, S;
  r === "button" ? S = {
    type: h,
    disabled: n
  } : S = {
    role: "button",
    tabIndex: n ? void 0 : 0,
    href: r === "a" && n ? void 0 : $,
    target: r === "a" ? p : void 0,
    type: r === "input" ? h : void 0,
    disabled: r === "input" ? n : void 0,
    "aria-disabled": !n || r === "input" ? void 0 : n,
    rel: r === "a" ? E : void 0
  };
  let { pressProps: D, isPressed: w } = ae({
    onPressStart: l,
    onPressEnd: o,
    onPressChange: d,
    onPress: i,
    onPressUp: s,
    isDisabled: n,
    preventFocusOnPress: c,
    ref: t
  }), { focusableProps: m } = Ae(e, t);
  g && (m.tabIndex = n ? -1 : m.tabIndex);
  let y = k(m, D, import_PjWeMm4_Z(e, {
    labelable: !0
  }));
  return {
    isPressed: w,
    buttonProps: k(S, y, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      onClick: (T) => {
        b && (b(T), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
function Lt(e, t, r) {
  let { validationBehavior: n, focus: i } = e;
  import_PjWeMm4_j(() => {
    if (n === "native" && (r != null && r.current)) {
      let d = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      r.current.setCustomValidity(d), r.current.hasAttribute("title") || (r.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(kr(r.current));
    }
  });
  let l = K(() => {
    t.resetValidation();
  }), o = K((d) => {
    var c;
    t.displayValidation.isInvalid || t.commitValidation();
    let g = r == null || (c = r.current) === null || c === void 0 ? void 0 : c.form;
    if (!d.defaultPrevented && r && g && Rr(g) === r.current) {
      var b;
      i ? i() : (b = r.current) === null || b === void 0 || b.focus(), import_PjWeMm4_Tr("keyboard");
    }
    d.preventDefault();
  }), s = K(() => {
    t.commitValidation();
  });
  (0,react.useEffect)(() => {
    let d = r == null ? void 0 : r.current;
    if (!d)
      return;
    let c = d.form;
    return d.addEventListener("invalid", o), d.addEventListener("change", s), c == null || c.addEventListener("reset", l), () => {
      d.removeEventListener("invalid", o), d.removeEventListener("change", s), c == null || c.removeEventListener("reset", l);
    };
  }, [
    r,
    o,
    s,
    l,
    n
  ]);
}
function Fr(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function kr(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: Fr(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function Rr(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let r = e.elements[t];
    if (!r.validity.valid)
      return r;
  }
  return null;
}
const Ot = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, Dt = {
  ...Ot,
  customError: !0,
  valid: !1
}, ee = {
  isInvalid: !1,
  validationDetails: Ot,
  validationErrors: []
}, zr = (0,react.createContext)({}), Fe = "__formValidationState" + Date.now();
function Be(e) {
  if (e[Fe]) {
    let { realtimeValidation: t, displayValidation: r, updateValidation: n, resetValidation: i, commitValidation: l } = e[Fe];
    return {
      realtimeValidation: t,
      displayValidation: r,
      updateValidation: n,
      resetValidation: i,
      commitValidation: l
    };
  }
  return Hr(e);
}
function Hr(e) {
  let { isInvalid: t, validationState: r, name: n, value: i, builtinValidation: l, validate: o, validationBehavior: s = "aria" } = e;
  r && (t || (t = r === "invalid"));
  let d = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: Dt
  } : null, c = (0,react.useMemo)(() => et(Kr(o, i)), [
    o,
    i
  ]);
  l != null && l.validationDetails.valid && (l = null);
  let g = (0,react.useContext)(zr), b = (0,react.useMemo)(() => n ? Array.isArray(n) ? n.flatMap((x) => ke(g[x])) : ke(g[n]) : [], [
    g,
    n
  ]), [$, p] = (0,react.useState)(g), [E, h] = (0,react.useState)(!1);
  g !== $ && (p(g), h(!1));
  let S = (0,react.useMemo)(() => et(E ? [] : b), [
    E,
    b
  ]), D = (0,react.useRef)(ee), [w, m] = (0,react.useState)(ee), y = (0,react.useRef)(ee), T = () => {
    if (!L)
      return;
    N(!1);
    let x = c || l || D.current;
    Te(x, y.current) || (y.current = x, m(x));
  }, [L, N] = (0,react.useState)(!1);
  return (0,react.useEffect)(T), {
    realtimeValidation: d || S || c || l || ee,
    displayValidation: s === "native" ? d || S || w : d || S || c || l || w,
    updateValidation(x) {
      s === "aria" && !Te(w, x) ? m(x) : D.current = x;
    },
    resetValidation() {
      let x = ee;
      Te(x, y.current) || (y.current = x, m(x)), s === "native" && N(!1), h(!0);
    },
    commitValidation() {
      s === "native" && N(!0), h(!0);
    }
  };
}
function ke(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function Kr(e, t) {
  if (typeof e == "function") {
    let r = e(t);
    if (r && typeof r != "boolean")
      return ke(r);
  }
  return [];
}
function et(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: Dt
  } : null;
}
function Te(e, t) {
  return e === t ? !0 : e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((r, n) => r === t.validationErrors[n]) && Object.entries(e.validationDetails).every(([r, n]) => t.validationDetails[r] === n);
}
function It(e, t, r) {
  let { isDisabled: n = !1, isReadOnly: i = !1, value: l, name: o, children: s, "aria-label": d, "aria-labelledby": c, validationState: g = "valid", isInvalid: b } = e, $ = (L) => {
    L.stopPropagation(), t.setSelected(L.target.checked);
  }, p = s != null, E = d != null || c != null;
  !p && !E && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: h, isPressed: S } = ae({
    isDisabled: n
  }), { pressProps: D, isPressed: w } = ae({
    isDisabled: n || i,
    onPress() {
      t.toggle();
    }
  }), { focusableProps: m } = Ae(e, r), y = k(h, m), T = import_PjWeMm4_Z(e, {
    labelable: !0
  });
  return vt(r, t.isSelected, t.setSelected), {
    labelProps: k(D, {
      onClick: (L) => L.preventDefault()
    }),
    inputProps: k(T, {
      "aria-invalid": b || g === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-controls": e["aria-controls"],
      "aria-readonly": i || void 0,
      onChange: $,
      disabled: n,
      ...l == null ? {} : {
        value: l
      },
      name: o,
      type: "checkbox",
      ...y
    }),
    isSelected: t.isSelected,
    isPressed: S || w,
    isDisabled: n,
    isReadOnly: i,
    isInvalid: b || g === "invalid"
  };
}
function Mt(e, t, r) {
  let n = Be({
    ...e,
    value: t.isSelected
  }), { isInvalid: i, validationErrors: l, validationDetails: o } = n.displayValidation, { labelProps: s, inputProps: d, isSelected: c, isPressed: g, isDisabled: b, isReadOnly: $ } = It({
    ...e,
    isInvalid: i
  }, t, r);
  Lt(e, n, r);
  let { isIndeterminate: p, isRequired: E, validationBehavior: h = "aria" } = e;
  return R(() => {
    r.current && (r.current.indeterminate = !!p);
  }), {
    labelProps: s,
    inputProps: {
      ...d,
      checked: c,
      "aria-required": E && h === "aria" || void 0,
      required: E && h === "native"
    },
    isSelected: c,
    isPressed: g,
    isDisabled: b,
    isReadOnly: $,
    isInvalid: i,
    validationErrors: l,
    validationDetails: o
  };
}
const Nr = /* @__PURE__ */ new WeakMap();
function _r(e) {
  let { id: t, label: r, "aria-labelledby": n, "aria-label": i, labelElementType: l = "label" } = e;
  t = import_PjWeMm4_pe(t);
  let o = import_PjWeMm4_pe(), s = {};
  r ? (n = n ? `${o} ${n}` : o, s = {
    id: o,
    htmlFor: l === "label" ? t : void 0
  }) : !n && !i && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let d = or({
    id: t,
    "aria-label": i,
    "aria-labelledby": n
  });
  return {
    labelProps: s,
    fieldProps: d
  };
}
function Ar(e) {
  let { description: t, errorMessage: r, isInvalid: n, validationState: i } = e, { labelProps: l, fieldProps: o } = _r(e), s = Ue([
    !!t,
    !!r,
    n,
    i
  ]), d = Ue([
    !!t,
    !!r,
    n,
    i
  ]);
  return o = k(o, {
    "aria-describedby": [
      s,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      d,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: l,
    fieldProps: o,
    descriptionProps: {
      id: s
    },
    errorMessageProps: {
      id: d
    }
  };
}
function We(e = {}) {
  let { isReadOnly: t } = e, [r, n] = bt(e.isSelected, e.defaultSelected || !1, e.onChange);
  function i(o) {
    t || n(o);
  }
  function l() {
    t || n(!r);
  }
  return {
    isSelected: r,
    setSelected: i,
    toggle: l
  };
}
function Br(e, t, r) {
  const n = We({
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isSelected: t.isSelected(e.value),
    onChange(S) {
      S ? t.addValue(e.value) : t.removeValue(e.value), e.onChange && e.onChange(S);
    }
  });
  let { name: i, descriptionId: l, errorMessageId: o, validationBehavior: s } = Nr.get(t);
  var d;
  s = (d = e.validationBehavior) !== null && d !== void 0 ? d : s;
  let { realtimeValidation: c } = Be({
    ...e,
    value: n.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  }), g = V(ee), b = () => {
    t.setInvalid(e.value, c.isInvalid ? c : g.current);
  };
  R(b);
  let $ = t.realtimeValidation.isInvalid ? t.realtimeValidation : c, p = s === "native" ? t.displayValidation : $;
  var E;
  let h = Mt({
    ...e,
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isDisabled: e.isDisabled || t.isDisabled,
    name: e.name || i,
    isRequired: (E = e.isRequired) !== null && E !== void 0 ? E : t.isRequired,
    validationBehavior: s,
    [Fe]: {
      realtimeValidation: $,
      displayValidation: p,
      resetValidation: t.resetValidation,
      commitValidation: t.commitValidation,
      updateValidation(S) {
        g.current = S, b();
      }
    }
  }, n, r);
  return {
    ...h,
    inputProps: {
      ...h.inputProps,
      "aria-describedby": [
        e["aria-describedby"],
        t.isInvalid ? o : null,
        l
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
const tt = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function Wr(e = {}) {
  let { style: t, isFocusable: r } = e, [n, i] = C(!1), { focusWithinProps: l } = wt({
    isDisabled: !r,
    onFocusWithinChange: (s) => i(s)
  }), o = W(() => n ? t : t ? {
    ...tt,
    ...t
  } : tt, [
    n
  ]);
  return {
    visuallyHiddenProps: {
      ...l,
      style: o
    }
  };
}
function Vt(e) {
  let { children: t, elementType: r = "div", isFocusable: n, style: i, ...l } = e, { visuallyHiddenProps: o } = Wr(e);
  return /* @__PURE__ */ O.createElement(r, k(l, o), t);
}
function Ur(e, t) {
  let { inputElementType: r = "input", isDisabled: n = !1, isRequired: i = !1, isReadOnly: l = !1, type: o = "text", validationBehavior: s = "aria" } = e, [d, c] = bt(e.value, e.defaultValue || "", e.onChange), { focusableProps: g } = Ae(e, t), b = Be({
    ...e,
    value: d
  }), { isInvalid: $, validationErrors: p, validationDetails: E } = b.displayValidation, { labelProps: h, fieldProps: S, descriptionProps: D, errorMessageProps: w } = Ar({
    ...e,
    isInvalid: $,
    errorMessage: e.errorMessage || p
  }), m = import_PjWeMm4_Z(e, {
    labelable: !0
  });
  const y = {
    type: o,
    pattern: e.pattern
  };
  return vt(t, d, c), Lt(e, b, t), (0,react.useEffect)(() => {
    if (t.current instanceof _(t.current).HTMLTextAreaElement) {
      let T = t.current;
      Object.defineProperty(T, "defaultValue", {
        get: () => T.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    t
  ]), {
    labelProps: h,
    inputProps: k(m, r === "input" && y, {
      disabled: n,
      readOnly: l,
      required: i && s === "native",
      "aria-required": i && s === "aria" || void 0,
      "aria-invalid": $ || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      value: d,
      onChange: (T) => c(T.target.value),
      autoComplete: e.autoComplete,
      autoCapitalize: e.autoCapitalize,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput,
      ...g,
      ...S
    }),
    descriptionProps: D,
    errorMessageProps: w,
    isInvalid: $,
    validationErrors: p,
    validationDetails: E
  };
}
function import_PjWeMm4_jr(e, t, r) {
  let { labelProps: n, inputProps: i, isSelected: l, isPressed: o, isDisabled: s, isReadOnly: d } = It(e, t, r);
  return {
    labelProps: n,
    inputProps: {
      ...i,
      role: "switch",
      checked: l
    },
    isSelected: l,
    isPressed: o,
    isDisabled: s,
    isReadOnly: d
  };
}
var import_PjWeMm4_Re = { exports: {} }, xe = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rt;
function Jr() {
  if (rt)
    return xe;
  rt = 1;
  var e = react;
  function t(b, $) {
    return b === $ && (b !== 0 || 1 / b === 1 / $) || b !== b && $ !== $;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, i = e.useEffect, l = e.useLayoutEffect, o = e.useDebugValue;
  function s(b, $) {
    var p = $(), E = n({ inst: { value: p, getSnapshot: $ } }), h = E[0].inst, S = E[1];
    return l(function() {
      h.value = p, h.getSnapshot = $, d(h) && S({ inst: h });
    }, [b, p, $]), i(function() {
      return d(h) && S({ inst: h }), b(function() {
        d(h) && S({ inst: h });
      });
    }, [b]), o(p), p;
  }
  function d(b) {
    var $ = b.getSnapshot;
    b = b.value;
    try {
      var p = $();
      return !r(b, p);
    } catch {
      return !0;
    }
  }
  function c(b, $) {
    return $();
  }
  var g = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return xe.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : g, xe;
}
var we = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nt;
function Gr() {
  return nt || (nt = 1,  false && 0), we;
}
 true ? import_PjWeMm4_Re.exports = Jr() : 0;
var Zr = import_PjWeMm4_Re.exports;
function qr(e, t, r) {
  let n = ot(), i = V(n);
  i.current = n;
  let l = F(() => i.current ? r() : t(), [
    t,
    r
  ]);
  return Zr.useSyncExternalStore(e, l);
}
typeof react.useSyncExternalStore == "function" && react.useSyncExternalStore;
const Yr = Symbol("callback"), it = Symbol("default");
function Xr({ values: e, children: t }) {
  for (let [r, n] of e)
    t = /* @__PURE__ */ react.createElement(r.Provider, {
      value: n
    }, t);
  return t;
}
function import_PjWeMm4_me(e) {
  let { className: t, style: r, children: n, defaultClassName: i, defaultChildren: l, values: o } = e;
  return (0,react.useMemo)(() => {
    let s, d, c;
    return typeof t == "function" ? s = t(o) : s = t, typeof r == "function" ? d = r(o) : d = r, typeof n == "function" ? c = n(o) : n == null ? c = l : c = n, {
      className: s ?? i,
      style: d,
      children: c,
      "data-rac": ""
    };
  }, [
    t,
    r,
    n,
    i,
    l,
    o
  ]);
}
function Qr(e, t) {
  let r = (0,react.useContext)(e);
  if (t === null)
    return null;
  if (r && typeof r == "object" && "slots" in r && r.slots) {
    if (!t && !r.slots[it])
      throw new Error("A slot prop is required");
    let n = t || it;
    if (!r.slots[n])
      throw new Error(`Invalid slot "${t}". Valid slot names are ` + new Intl.ListFormat().format(Object.keys(r.slots).map((i) => `"${i}"`)) + ".");
    return r.slots[n];
  }
  return r;
}
function import_PjWeMm4_ye(e, t, r) {
  let n = Qr(r, e.slot) || {}, { ref: i, [Yr]: l, ...o } = n, s = lr((0,react.useMemo)(() => Jt(t, i), [
    t,
    i
  ])), d = k(o, e);
  return (0,react.useEffect)(() => {
    l && l(e);
  }, [
    l,
    e
  ]), [
    d,
    s
  ];
}
function en() {
  let [e, t] = (0,react.useState)(!0), r = (0,react.useRef)(!1), n = (0,react.useCallback)((i) => {
    r.current = !0, t(!!i);
  }, []);
  return import_PjWeMm4_j(() => {
    r.current || t(!1);
  }, []), [
    n,
    e
  ];
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const tn = /* @__PURE__ */ (0,react.createContext)(!1);
typeof DocumentFragment < "u" && new DocumentFragment();
function rn(e) {
  let t = (r, n) => (0,react.useContext)(tn) ? null : e(r, n);
  return t.displayName = e.displayName || e.name, react.forwardRef(t);
}
function Ct(e) {
  const t = /^(data-.*)$/;
  let r = {};
  for (const n in e)
    t.test(n) || (r[n] = e[n]);
  return r;
}
const nn = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), an = /* @__PURE__ */ (0,react.createContext)({});
function on(e, t) {
  [e, t] = import_PjWeMm4_ye(e, t, an);
  let r = e, { buttonProps: n, isPressed: i } = Cr(e, t), { focusProps: l, isFocused: o, isFocusVisible: s } = _e(e), { hoverProps: d, isHovered: c } = Ne(e), g = import_PjWeMm4_me({
    ...e,
    values: {
      isHovered: c,
      isPressed: i,
      isFocused: o,
      isFocusVisible: s,
      isDisabled: e.isDisabled || !1
    },
    defaultClassName: "react-aria-Button"
  });
  return /* @__PURE__ */ react.createElement("button", {
    ...import_PjWeMm4_Z(e, {
      propNames: nn
    }),
    ...k(n, l, d),
    ...g,
    ref: t,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": r.isPressed || i || void 0,
    "data-hovered": c || void 0,
    "data-focused": o || void 0,
    "data-focus-visible": s || void 0
  });
}
const hn = /* @__PURE__ */ rn(on), ln = /* @__PURE__ */ (0,react.createContext)({}), sn = /* @__PURE__ */ (0,react.createContext)({}), dn = /* @__PURE__ */ (/* unused pure expression or super */ null && (A(null))), un = /* @__PURE__ */ (/* unused pure expression or super */ null && (A(null)));
function cn(e, t) {
  [e, t] = import_PjWeMm4_ye(e, t, un);
  let r = U(dn), { inputProps: n, isSelected: i, isDisabled: l, isReadOnly: o, isPressed: s } = r ? Br({
    ...e,
    // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
    // it's passed explicitly here to avoid typescript error (requires ignore).
    // @ts-ignore
    value: e.value,
    // ReactNode type doesn't allow function children.
    children: typeof e.children == "function" ? !0 : e.children
  }, r, t) : Mt({
    ...e,
    children: typeof e.children == "function" ? !0 : e.children
  }, We(e), t), { isFocused: d, isFocusVisible: c, focusProps: g } = _e(), b = l || o, [$, p] = C(!1), { pressProps: E } = ae({
    isDisabled: b,
    onPressStart(y) {
      y.pointerType !== "keyboard" && p(!0);
    },
    onPressEnd(y) {
      y.pointerType !== "keyboard" && p(!1);
    }
  }), { hoverProps: h, isHovered: S } = Ne({
    isDisabled: b
  }), D = b ? !1 : $ || s, w = import_PjWeMm4_me({
    // TODO: should data attrs go on the label or on the <input>? useCheckbox passes them to the input...
    ...e,
    defaultClassName: "react-aria-Checkbox",
    values: {
      isSelected: i,
      isIndeterminate: e.isIndeterminate || !1,
      isPressed: D,
      isHovered: S,
      isFocused: d,
      isFocusVisible: c,
      isDisabled: l,
      isReadOnly: o,
      isInvalid: e.isInvalid || (r == null ? void 0 : r.isInvalid) || !1,
      isRequired: e.isRequired || !1
    }
  }), m = import_PjWeMm4_Z(e);
  return delete m.id, /* @__PURE__ */ O.createElement("label", {
    ...k(m, E, h, w),
    slot: e.slot || void 0,
    "data-selected": i || void 0,
    "data-indeterminate": e.isIndeterminate || void 0,
    "data-pressed": D || void 0,
    "data-hovered": S || void 0,
    "data-focused": d || void 0,
    "data-focus-visible": c || void 0,
    "data-disabled": l || void 0,
    "data-readonly": o || void 0,
    "data-invalid": e.isInvalid || (r == null ? void 0 : r.isInvalid) || void 0,
    "data-required": e.isRequired || void 0
  }, /* @__PURE__ */ O.createElement(Vt, {
    elementType: "span"
  }, /* @__PURE__ */ O.createElement("input", {
    ...n,
    ...g,
    ref: t
  })), w.children);
}
const Pn = /* @__PURE__ */ (/* unused pure expression or super */ null && (ze(cn))), fn = /* @__PURE__ */ (0,react.createContext)({});
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"حدد عنصرًا","tableResizer":"أداة تغيير الحجم"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Изберете предмет","tableResizer":"Преоразмерител"}');
JSON.parse('{"dropzoneLabel":"Místo pro přetažení","selectPlaceholder":"Vyberte položku","tableResizer":"Změna velikosti"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Vælg et element","tableResizer":"Størrelsesændring"}');
JSON.parse('{"dropzoneLabel":"Ablegebereich","selectPlaceholder":"Element wählen","tableResizer":"Größenanpassung"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Επιλέξτε ένα αντικείμενο","tableResizer":"Αλλαγή μεγέθους"}');
JSON.parse('{"selectPlaceholder":"Select an item","tableResizer":"Resizer","dropzoneLabel":"DropZone"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Seleccionar un artículo","tableResizer":"Cambiador de tamaño"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Valige üksus","tableResizer":"Suuruse muutja"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Valitse kohde","tableResizer":"Koon muuttaja"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Sélectionner un élément","tableResizer":"Redimensionneur"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"בחר פריט","tableResizer":"שינוי גודל"}');
JSON.parse('{"dropzoneLabel":"Zona spuštanja","selectPlaceholder":"Odaberite stavku","tableResizer":"Promjena veličine"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Válasszon ki egy elemet","tableResizer":"Átméretező"}');
JSON.parse('{"dropzoneLabel":"Zona di rilascio","selectPlaceholder":"Seleziona un elemento","tableResizer":"Ridimensionamento"}');
JSON.parse('{"dropzoneLabel":"ドロップゾーン","selectPlaceholder":"項目を選択","tableResizer":"サイズ変更ツール"}');
JSON.parse('{"dropzoneLabel":"드롭 영역","selectPlaceholder":"항목 선택","tableResizer":"크기 조정기"}');
JSON.parse('{"dropzoneLabel":"„DropZone“","selectPlaceholder":"Pasirinkite elementą","tableResizer":"Dydžio keitiklis"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Izvēlēties vienumu","tableResizer":"Izmēra mainītājs"}');
JSON.parse('{"dropzoneLabel":"Droppsone","selectPlaceholder":"Velg et element","tableResizer":"Størrelsesendrer"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Selecteer een item","tableResizer":"Resizer"}');
JSON.parse('{"dropzoneLabel":"Strefa upuszczania","selectPlaceholder":"Wybierz element","tableResizer":"Zmiana rozmiaru"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Selecione um item","tableResizer":"Redimensionador"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Selecione um item","tableResizer":"Redimensionador"}');
JSON.parse('{"dropzoneLabel":"Zonă de plasare","selectPlaceholder":"Selectați un element","tableResizer":"Instrument de redimensionare"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Выберите элемент","tableResizer":"Средство изменения размера"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Vyberte položku","tableResizer":"Nástroj na zmenu veľkosti"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Izberite element","tableResizer":"Spreminjanje velikosti"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Izaberite stavku","tableResizer":"Promena veličine"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Välj en artikel","tableResizer":"Storleksändrare"}');
JSON.parse('{"dropzoneLabel":"Bırakma Bölgesi","selectPlaceholder":"Bir öğe seçin","tableResizer":"Yeniden boyutlandırıcı"}');
JSON.parse('{"dropzoneLabel":"DropZone","selectPlaceholder":"Виберіть елемент","tableResizer":"Засіб змінення розміру"}');
JSON.parse('{"dropzoneLabel":"放置区域","selectPlaceholder":"选择一个项目","tableResizer":"尺寸调整器"}');
JSON.parse('{"dropzoneLabel":"放置區","selectPlaceholder":"選取項目","tableResizer":"大小調整器"}');
const pn = /* @__PURE__ */ (/* unused pure expression or super */ null && (A(null)));
function vn(e, t) {
  [e, t] = import_PjWeMm4_ye(e, t, pn);
  let r = We(e), { inputProps: n, isSelected: i, isDisabled: l, isReadOnly: o, isPressed: s } = import_PjWeMm4_jr({
    ...Ct(e),
    // ReactNode type doesn't allow function children.
    children: typeof e.children == "function" ? !0 : e.children
  }, r, t), { isFocused: d, isFocusVisible: c, focusProps: g } = _e(), b = e.isDisabled || e.isReadOnly, [$, p] = C(!1), { pressProps: E } = ae({
    isDisabled: b,
    onPressStart(y) {
      y.pointerType !== "keyboard" && p(!0);
    },
    onPressEnd(y) {
      y.pointerType !== "keyboard" && p(!1);
    }
  }), { hoverProps: h, isHovered: S } = Ne({
    isDisabled: b
  }), D = b ? !1 : $ || s, w = import_PjWeMm4_me({
    ...e,
    defaultClassName: "react-aria-Switch",
    values: {
      isSelected: i,
      isPressed: D,
      isHovered: S,
      isFocused: d,
      isFocusVisible: c,
      isDisabled: l,
      isReadOnly: o,
      state: r
    }
  }), m = import_PjWeMm4_Z(e);
  return delete m.id, /* @__PURE__ */ O.createElement("label", {
    ...k(m, E, h, w),
    slot: e.slot || void 0,
    "data-selected": i || void 0,
    "data-pressed": D || void 0,
    "data-hovered": S || void 0,
    "data-focused": d || void 0,
    "data-focus-visible": c || void 0,
    "data-disabled": l || void 0,
    "data-readonly": o || void 0
  }, /* @__PURE__ */ O.createElement(Vt, {
    elementType: "span"
  }, /* @__PURE__ */ O.createElement("input", {
    ...n,
    ...g,
    ref: t
  })), w.children);
}
const En = /* @__PURE__ */ (/* unused pure expression or super */ null && (ze(vn))), bn = /* @__PURE__ */ (0,react.createContext)({}), $n = /* @__PURE__ */ (0,react.createContext)(null);
function gn(e, t) {
  [e, t] = import_PjWeMm4_ye(e, t, $n);
  let r = (0,react.useRef)(null), [n, i] = en(), [l, o] = (0,react.useState)("input"), { labelProps: s, inputProps: d, descriptionProps: c, errorMessageProps: g } = Ur({
    ...Ct(e),
    inputElementType: l,
    label: i
  }, r), b = (0,react.useCallback)((p) => {
    r.current = p, p && o(p instanceof HTMLTextAreaElement ? "textarea" : "input");
  }, []), $ = import_PjWeMm4_me({
    ...e,
    values: {
      isDisabled: e.isDisabled || !1,
      isInvalid: e.isInvalid || !1
    },
    defaultClassName: "react-aria-TextField"
  });
  return /* @__PURE__ */ react.createElement("div", {
    ...import_PjWeMm4_Z(e),
    ...$,
    ref: t,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": e.isInvalid || void 0
  }, /* @__PURE__ */ react.createElement(Xr, {
    values: [
      [
        sn,
        {
          ...s,
          ref: n
        }
      ],
      [
        fn,
        {
          ...d,
          ref: b
        }
      ],
      [
        bn,
        {
          ...d,
          ref: b
        }
      ],
      [
        ln,
        {
          slots: {
            description: c,
            errorMessage: g
          }
        }
      ]
    ]
  }, $.children));
}
(0,react.forwardRef)(gn);

//# sourceMappingURL=import-_PjWeMm4.js.map

;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/Button-BNj0TeuP.js




/* empty css                              */
var b = Re({ defaultClassName: "_1kgv65v2", variantClassNames: { theme: { dark: "_1kgv65v3", light: "_1kgv65v4" }, variant: { primary: "_1kgv65v5", secondary: "_1kgv65v6", tertiary: "_1kgv65v7" }, size: { small: "_1kgv65v8", medium: "_1kgv65v9", large: "_1kgv65va" }, iconLayout: { sx: "_1kgv65vb", dx: "_1kgv65vc" } }, defaultVariants: {}, compoundVariants: [[{ theme: "dark", variant: "primary" }, "_1kgv65vd"], [{ theme: "light", variant: "primary" }, "_1kgv65ve"], [{ theme: "dark", variant: "secondary" }, "_1kgv65vf"], [{ theme: "light", variant: "secondary" }, "_1kgv65vg"], [{ theme: "dark", variant: "tertiary" }, "_1kgv65vh"], [{ theme: "light", variant: "tertiary" }, "_1kgv65vi"]] }), u = Re({ defaultClassName: "gbijxg1", variantClassNames: { size: { small: "gbijxg2", medium: "gbijxg3", large: "gbijxg4" } }, defaultVariants: {}, compoundVariants: [] }), Button_BNj0TeuP_k = Re({ defaultClassName: "gbijxg5", variantClassNames: { theme: { dark: "gbijxg6", light: "gbijxg7" }, variant: { primary: "gbijxg8", secondary: "gbijxg9", tertiary: "gbijxga" }, size: { small: "gbijxgb", medium: "gbijxgc", large: "gbijxgd" } }, defaultVariants: {}, compoundVariants: [[{ theme: "dark", variant: "primary" }, "gbijxge"], [{ theme: "dark", variant: "secondary" }, "gbijxgf"], [{ theme: "light", variant: "primary" }, "gbijxgg"], [{ theme: "light", variant: "secondary" }, "gbijxgh"]] }), c = Re({ defaultClassName: "gbijxgi", variantClassNames: { variant: { primary: "gbijxgj", secondary: "gbijxgk", tertiary: "gbijxgl" }, theme: { dark: "gbijxgm", light: "gbijxgn" }, size: { small: "gbijxgo", medium: "gbijxgp", large: "gbijxgq" } }, defaultVariants: {}, compoundVariants: [[{ theme: "dark", variant: "primary" }, "gbijxgr"], [{ theme: "dark", variant: "secondary" }, "gbijxgs"], [{ theme: "light", variant: "primary" }, "gbijxgt"], [{ theme: "light", variant: "secondary" }, "gbijxgu"]] });
const h = ({ size: i, theme: t, variant: a }) => /* @__PURE__ */ Ee.jsxs("div", { className: u({ size: i }), children: [
  /* @__PURE__ */ Ee.jsx("div", { className: Button_BNj0TeuP_k({ size: i, theme: t, variant: a }) }),
  /* @__PURE__ */ Ee.jsx("div", { className: c({ size: i, theme: t, variant: a }) })
] }), Button_BNj0TeuP_y = (0,react.forwardRef)(({
  children: i,
  disabled: t = !1,
  loading: a = !1,
  variant: v = "primary",
  theme: s = "dark",
  icon: m,
  iconLayout: l = "sx",
  size: e = "medium",
  ...d
}, x) => /* @__PURE__ */ Ee.jsxs(
  hn,
  {
    ...d,
    ref: x,
    isDisabled: t,
    className: b({ iconLayout: l, size: e, theme: s, variant: v }),
    children: [
      a && /* @__PURE__ */ Ee.jsx(h, { size: e, theme: s }),
      !a && m ? m : null,
      !a && (e === "small" || e === "medium") ? /* @__PURE__ */ Ee.jsx(Typography_2ZjCxfuP_C, { size: "m", strong: !0, noMargin: !0, children: i }) : null,
      !a && e === "large" ? /* @__PURE__ */ Ee.jsx(Typography_2ZjCxfuP_C, { size: "l", strong: !0, noMargin: !0, children: i }) : null
    ]
  }
));
Button_BNj0TeuP_y.displayName = "Button";

//# sourceMappingURL=Button-BNj0TeuP.js.map

;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/Badge-BE18ezuy.js

/* empty css                              */

const Badge_BE18ezuy_o = () => /* @__PURE__ */ Ee.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Ee.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8 2L14 3.2L9.19976 7.99994L14 12.8L12.8 14L7.99994 9.19976L3.2 14L2 12.8L6.79928 7.99994L2 3.2L3.2 2L7.99994 6.79928L12.8 2Z",
        fill: "#BC4646"
      }
    )
  }
), Badge_BE18ezuy_a = () => /* @__PURE__ */ Ee.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Ee.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.3484 2L14.6667 3.1916L6.00701 14L1.33337 9.82676L2.44729 8.41938L5.80333 11.4157L13.3484 2Z",
        fill: "#529A46"
      }
    )
  }
), g = () => /* @__PURE__ */ Ee.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Ee.jsx(
      "path",
      {
        d: "M8.00002 3.99325L13.02 12.6666H2.98002L8.00002 3.99325ZM8.00002 1.33325L0.666687 13.9999H15.3334L8.00002 1.33325ZM8.66669 10.6666H7.33335V11.9999H8.66669V10.6666ZM8.66669 6.66659H7.33335V9.33325H8.66669V6.66659Z",
        fill: "#CC9A36"
      }
    )
  }
);
var Badge_BE18ezuy_c = Re({ defaultClassName: "lg8yeu0", variantClassNames: { theme: { dark: "lg8yeu1", light: "lg8yeu2" }, status: { error: "lg8yeu3", success: "lg8yeu4", warning: "lg8yeu5" } }, defaultVariants: {}, compoundVariants: [] });
const Badge_BE18ezuy_d = {
  error: /* @__PURE__ */ Ee.jsx(Badge_BE18ezuy_o, {}),
  success: /* @__PURE__ */ Ee.jsx(Badge_BE18ezuy_a, {}),
  warning: /* @__PURE__ */ Ee.jsx(g, {})
}, w = ({
  children: n,
  icon: r,
  status: s,
  theme: l = "light"
}) => /* @__PURE__ */ e.jsxs("span", { className: Badge_BE18ezuy_c({ status: s, theme: l }), children: [
  s ? Badge_BE18ezuy_d[s] : r,
  /* @__PURE__ */ e.jsx(i, { size: "s", noMargin: !0, children: n })
] });

//# sourceMappingURL=Badge-BE18ezuy.js.map

;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/Switch-BoUWWFW5.js


/* empty css                              */
var n = "_1w853300", Switch_BoUWWFW5_l = Re({ defaultClassName: "_1w853302 _1w853301", variantClassNames: { size: { normal: "_1w853303", small: "_1w853304" } }, defaultVariants: {}, compoundVariants: [] });
const f = ({
  size: e = "normal",
  onChange: a,
  isSelected: s,
  disabled: t
}) => {
  const o = {
    ...a ? { onChange: a } : {},
    ...typeof s < "u" ? { isSelected: s } : {}
  };
  return /* @__PURE__ */ r.jsx(
    m,
    {
      className: n,
      isDisabled: t || !1,
      ...o,
      children: /* @__PURE__ */ r.jsx("div", { className: Switch_BoUWWFW5_l({ size: e }) })
    }
  );
};

//# sourceMappingURL=Switch-BoUWWFW5.js.map

;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/Checkbox-CIt7C3d4.js


/* empty css                              */


var Checkbox_CIt7C3d4_d = "_1g2c7v70", Checkbox_CIt7C3d4_v = Re({ defaultClassName: "_1g2c7v71", variantClassNames: { checked: { true: "_1g2c7v72" }, disabled: { true: "_1g2c7v73" }, error: { true: "_1g2c7v74" } }, defaultVariants: {}, compoundVariants: [[{ checked: !0, error: !0 }, "_1g2c7v75"]] }), Checkbox_CIt7C3d4_g = "_1g2c7v76";
const Checkbox_CIt7C3d4_j = ({
  checked: e,
  children: c,
  disabled: s,
  error: a,
  message: i,
  ...l
}) => /* @__PURE__ */ r.jsxs(
  m,
  {
    ...l,
    isDisabled: s,
    isSelected: e,
    className: Checkbox_CIt7C3d4_d,
    children: [
      /* @__PURE__ */ r.jsx(
        "div",
        {
          "data-id": "check-icon",
          className: Checkbox_CIt7C3d4_v({ checked: e, disabled: s, error: a }),
          children: e && /* @__PURE__ */ r.jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              children: /* @__PURE__ */ r.jsx(
                "path",
                {
                  d: "M4.35982 7.39202L2.87769 8.73317L6.5114 12.7572L13.5542 5.70712L12.1414 4.29291L6.58447 9.85565L4.35982 7.39202Z",
                  fill: s ? t.colors.root.neutral[300] : t.colors.root.neutral[0]
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ r.jsx(o, { noMargin: !0, children: c }),
      a && /* @__PURE__ */ r.jsx("div", { className: Checkbox_CIt7C3d4_g, children: /* @__PURE__ */ r.jsx(o, { noMargin: !0, size: "s", color: "root.red.600", children: i || "error message" }) })
    ]
  }
);

//# sourceMappingURL=Checkbox-CIt7C3d4.js.map

;// CONCATENATED MODULE: ./node_modules/@casavo/habitat/dist/index.js






const dist_a = {
  space: {
    0: 0,
    25: 2,
    50: 4,
    75: 6,
    100: 8,
    125: 10,
    150: 12,
    175: 14,
    200: 16,
    225: 18,
    250: 20,
    300: 24,
    400: 32,
    500: 40,
    600: 48,
    800: 64,
    1e3: 80,
    1800: 144
  },
  corner: {
    50: 4,
    100: 8,
    200: 16,
    300: 24,
    400: 32,
    1e3: 800
  },
  foreground: {
    critical: {
      default: "#eb5757ff",
      light: "#fdeeeeff"
    },
    success: {
      default: "#7dbe64ff",
      background: "#f2f9efff"
    },
    warning: {
      default: "#f5c35cff",
      light: "#fef9edff"
    },
    text: {
      primary: "#1d1d1bff",
      secondary: "#525251ff",
      inverted: "#ffffffff",
      hover: "#737372ff",
      placeholder: "#b3b3b2ff"
    },
    border: {
      default: "#b3b3b2ff",
      "hover, active": "#ff991fff",
      critical: "#eb5757ff",
      disabled: "#e8e8e8ff"
    },
    surface: {
      disabled: "#f5f5f5ff",
      default: "#ffffffff",
      "pressed, active": "#fff5e9ff"
    }
  },
  root: {
    orange: {
      300: "#fff5e9ff",
      400: "#ffc279ff",
      500: "#ff991fff",
      600: "#e68a1cff",
      700: "#c17e34ff"
    },
    darkgreen: {
      300: "#edf2f1ff",
      400: "#cdd8d7ff",
      500: "#063d39ff",
      600: "#05332fff",
      700: "#021a18ff"
    },
    teal: {
      500: "#25c1a3ff"
    },
    neutral: {
      0: "#ffffffff",
      50: "#f5f5f5ff",
      100: "#e8e8e8ff",
      200: "#d4d4d3ff",
      300: "#b3b3b2ff",
      400: "#737372ff",
      500: "#525251ff",
      600: "#1d1d1bff"
    },
    red: {
      100: "#fdeeeeff",
      200: "#f39a9aff",
      300: "#ff5e5eff",
      400: "#eb5757ff",
      500: "#c45753ff",
      600: "#ae4e4aff"
    },
    green: {
      100: "#f2f9efff",
      200: "#afd7a0ff",
      300: "#95cb82ff",
      400: "#7dbe64ff",
      500: "#71ab5aff",
      600: "#649850ff"
    },
    yellow: {
      100: "#fef9edff",
      200: "#f9da98ff",
      300: "#f7cf79ff",
      400: "#f5c35cff",
      500: "#ddaf52ff",
      600: "#c49c49ff"
    },
    offwhite: {
      100: "#f6f6f1ff"
    },
    glass: {
      100: "#e0f4fdff"
    }
  },
  background: {
    default: {
      light: "#ffffffff",
      dark: "#f6f6f1ff"
    },
    primary: {
      dark: "#ff991fff",
      light: "#fff5e9ff"
    },
    secondary: {
      dark: "#063d39ff",
      light: "#edf2f1ff"
    }
  },
  brand: {
    primary: "#ff991fff",
    secondary: "#063d39ff",
    accent: "#25c1a3ff",
    "primary-light": "#fff5e9ff",
    "secondary-light": "#edf2f1ff"
  }
}, dist_o = {
  light: {
    text: {
      primary: "#1d1d1bff",
      inverted: "#ffffffff",
      disabled: "#737372ff",
      round: "#1d1d1bff"
    },
    background: {
      default: "#1d1d1bff",
      inverted: "#ffffffff",
      hover: "#737372ff",
      "hover-tertiary": "#e8e8e8ff",
      "active, pressed": "#525251ff",
      disabled: "#e8e8e8ff",
      "round-default": "#e8e8e8ff",
      "round-hover": "#d4d4d3ff"
    },
    border: {
      default: "#1d1d1bff",
      hover: "#737372ff",
      "active, pressed": "#525251ff",
      disabled: "#e8e8e8ff",
      "hover-tertiary": "#e8e8e8ff",
      "round-default": "#ffffffff",
      "round-hover": "#f5f5f5ff"
    }
  },
  dark: {
    text: {
      primary: "#ffffffff",
      inverted: "#1d1d1bff",
      disabled: "#737372ff",
      round: "#1d1d1bff"
    },
    background: {
      default: "#ffffffff",
      inverted: "#737372ff",
      hover: "#e8e8e8ff",
      "hover-tertiary": "#e8e8e8ff",
      "active, pressed": "#d4d4d3ff",
      disabled: "#e8e8e8ff",
      "round-default": "#ffffffff",
      "round-hover": "#f5f5f5ff"
    },
    border: {
      default: "#ffffffff",
      hover: "#e8e8e8ff",
      "active, pressed": "#525251ff",
      disabled: "#e8e8e8ff",
      "hover-tertiary": "#e8e8e8ff",
      "round-default": "#ffffffff",
      "round-hover": "#f5f5f5ff"
    }
  }
}, dist_f = {
  foundations: dist_a,
  buttons: dist_o
}, s = {
  background: dist_f.foundations.background,
  brand: dist_f.foundations.brand,
  buttons: dist_f.buttons,
  foreground: dist_f.foundations.foreground,
  root: dist_f.foundations.root
}, dist_n = dist_f.foundations.corner, dist_i = Object.entries(dist_n).reduce((e, [d, r]) => (e[d] = `${r}px`, e), {}), dist_t = dist_f.foundations.space;
[...Object.values(dist_t)].map(String);
const dist_c = Object.entries(dist_t).reduce(
  (e, [d, r]) => (e[d] = `${r}px`, e),
  {}
), dist_b = {
  desktop: "(min-width: 1024px)",
  desktopHD: "(min-width: 1440px)",
  desktopSD: "(min-width: 960px)",
  mobile: "(min-width: 360px)",
  tablet: "(min-width: 768px)"
};

//# sourceMappingURL=index.js.map


/***/ })

}]);